<template>
    <div class="wrapper">
      <div class="content">
        <div class="form_wrap" id="form_wrap" >
          <h3 class="form_title">申请试用</h3>
          <div class="apply_form">
            <div>
              <label class="icon username_icon"></label>
              <input type="text" id="username" placeholder="姓名" class="message"  autocomplete="off">
              <span class="err" id="username_err"></span>
            </div>
            <div>
              <label class="icon company_name_icon"></label>
              <input type="text" id="company_name" placeholder="公司" class="message"  autocomplete="off">
              <span class="err" id="company_name_err"></span>
            </div>
            <div>
              <label class="icon email_icon"></label>
              <input type="text" id="email" placeholder="邮箱" class="message"  autocomplete="off">
              <span class="err" id="email_err"></span>
            </div>
            <div>
              <label class="icon tel_icon"></label>
              <input type="text" id="tel" placeholder="手机" class="message"  autocomplete="off">
              <span class="err" id="tel_err"></span>
            </div>
            <div>
              <input type="text" placeholder="验证码" id="captcha"><!--
                --><div id="v_container" style="display: inline-block; width: 135px;height: 37px;"></div>
              <span class="barter">看不清？<a href="javascritp:;" id="barter" @click="barter">换一张</a></span>
            </div>
            <div class="application_content">
              申请内容
              <label class="label_checkbox"><input type="checkbox" id="ai" v-model="isAi"><span></span></label>
              <span style="font-size: 16px">视觉内容分析平台</span>
              <label class="label_checkbox"><input type="checkbox" id="video_data" v-model="isVideoData"><span></span></label>
              <span style="font-size: 16px">视觉信息提取平台</span>
              <label class="label_checkbox label_checkbox_image"><input type="checkbox" id="image" v-model="isImage"><span></span></label>
              <span style="font-size: 16px">视觉搜索平台</span>
            </div>
            <div class="btn">
              <a href="javascript:;" id="submit_btn" class="submit_btn" @click="submitBtn">提交申请</a>
            </div>
          </div>
        </div>
        <div class="success_msg" id="success_msg">
          <h3 class="form_title">提交成功</h3>
          <div >已提交成功！审核通过后会将账号发送到您的邮箱，请及时查收</div>
        </div>
      </div>
    </div>
</template>

<script>
	import '../../static/js/gVerify'
	import CryptoJS from 'crypto-js'
	import bus from '../utils/bus'

	//签名验证
  function getUploadSignKey(secret_key,timestamp,params) {
    //console.log(params)

    function sign(secret_key, params) {
      //console.log(params)
      var keys = Object.keys(params);
      keys.sort();
      var sign_string = '';

      for (var i=0; i<keys.length; i++) {
        var key = keys[i];
        sign_string += key.toString();
        sign_string += params[key].toString();

      }
      sign_string += timestamp.toString();
      sign_string += secret_key.toString();
      var hash = CryptoJS.MD5(sign_string);
      return hash.toString().toUpperCase();
    }
    return  sign(secret_key, params)
  }
  //格式验证
  //验证邮箱
  function isEmail(email) {
    var pattern = /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/
    return pattern.test(email);
  }
  // 验证手机号
  function isPhoneNo(phone) {
    var pattern = /^1[34578]\d{9}$/;
    return pattern.test(phone);
  }
  // 验证函数
  function formValidate() {
    var str = '';
    $('.err').hide()
    // 判断名称
    $('#username').blur(function () {
      if($.trim($('#username').val()).length == 0) {
        str = '用户姓名不能为空';
        $('#username_err').html(str).show()
        $('#username').addClass('input_err');
      }else {
        $('#username_err').html('').hide()
        $('#username').removeClass('input_err');
        str = '';
      }
    })

    $('#company_name').blur(function () {
      if($.trim($('#company_name').val()).length == 0) {
        str = '公司名称不能为空'
        $('#company_name_err').html(str).show()
        $('#company_name').addClass('input_err')
      }else {
        $('#company_name_err').html('').hide()
        $('#company_name').removeClass('input_err');
        str = ''
      }
    })

    $('#email').blur(function () {
      if($.trim($('#email').val()).length == 0) {
        str = '邮箱不能为空';
        $('#email_err').html(str).show()
        $('#email').addClass('input_err')
      }else if(isEmail($.trim($('#email').val())) == false){
        str = '邮箱格式不正确';
        $('#email_err').html(str).show()
        $('#email').addClass('input_err')
      }else {
        $('#email_err').html('').hide()
        $('#email').removeClass('input_err');
        str = '';
      }
    })
    $('#tel').blur(function () {
      if($.trim($('#tel').val()).length == 0) {
        str = '手机号码不能为空';
        $('#tel_err').html(str).show()
        $('#tel').addClass('input_err')
      }else if(isPhoneNo($.trim($('#tel').val())) == false){
        str = '手机号码格式不正确';
        $('#tel_err').html(str).show()
        $('#tel').addClass('input_err')
      }else {
        $('#tel_err').html('').hide()
        $('#tel').removeClass('input_err');
        str = '';
      }
    })
  }

  export default {
      data(){
        return{
          isAi:'',
          isVideoData:'',
	        isImage:''
        }
      },
      created(){
        this.$nextTick(()=>{
          this.verifyCode = new GVerify("v_container");
          formValidate()
        })
      },
      mounted(){
        bus.$emit('customEvent','trial');
      },
      methods:{
        barter(ev){
          this.verifyCode.refresh();
          ev.preventDefault();
        },
        submitBtn(){
          let res = this.verifyCode.validate($('#captcha').val());
          // console.log($('#company_name').val());
          if(res){//验证码正确
            formValidate()
            var ACCESS_KEY="8c0eee918fe2b8a1b7989b3cdb316329",
              SECRET_KEY="Ss0mR3dLpNNQQbuFFJiAng2MLa0raRfezGvnHnU";
            var timestamp = (new Date()).valueOf();
            timestamp=Math.floor(timestamp/1000);
            var apply_platform = ''
            if (this.isAi&&this.isVideoData&&this.isImage){
              apply_platform = '100,200,300'
            }else if (this.isAi&&this.isVideoData){
	            apply_platform = '100,200'
            }else if (this.isAi&&this.isImage){
	            apply_platform = '100,300'
            }else if (this.isVideoData&&this.isVideoData){
	            apply_platform = '200,300'
            }else if (this.isAi){
              apply_platform = '100'
            }else if (this.isVideoData){
              apply_platform = '200'
            }else if (this.isImage){
	            apply_platform = '300'
            }else {
              alert('请选择申请内容')
              return false
            }


            var params = {
              "company_name": $.trim($('#company_name').val()),           //公司名称
              "name": $.trim($('#username').val()),                 //姓名
              "email": $.trim($('#email').val()),         //邮箱
              "mobile": $.trim($('#tel').val()),        //电话
              "apply_platform": apply_platform    //试用平台（多选）
            }
            var  SIGN_KEY=getUploadSignKey(SECRET_KEY,timestamp,params);
            $.ajax({
              type: 'POST',
              url: "http://123.57.156.26:80/application/add-application",
              data:{
                accessKey:ACCESS_KEY,
                timestamp:timestamp,
                sign:SIGN_KEY,
                params:params
              } ,
              async: false,
              success: function (data) {
                console.log(data);
                var code = data.code
                if (code === 1){
                  $('#form_wrap').hide()
                  $('#success_msg').show()
                }else {
                  alert('提交失败，请稍后重新提交')
                }

              }
            });
          }else{//验证码错误
            alert("验证码错误");
          }
        }
      }
    }
</script>

<style>
  @media screen and (min-width: 768px){
    input{
      padding: 0;
      margin: 0;
      box-sizing: border-box;
      outline:none;
    }
    .err{
      font-size: 12px;
      color: #f95710 ;
      position: absolute;
      right: 45px;
      bottom: -15px;
    }
    #tel_number {
      margin-left: 32px;
    }
    .index_part1{
      position: relative;
      width:100%;
      min-width: 1152px;
    }

    /*内容*/
    #app{
      height: 100%;
    }
    .wrapper{
      height: 100%;
    }
    body,html{
      height: 100%;
    }
    .content{
      height: 100%;
      padding-top: 120px;
      background: url(http://bu.dressplus.cn/web/img/trial_bj.png) center no-repeat;
    }
    .form_wrap{
      /*border: 1px solid #000;*/
      width: 512px;
      height: 540px;
      /* margin: 0 auto;*/
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-256px,-270px);
    }
    .success_msg{
      width: 512px;
      height: 540px;
      margin: 0 auto;
      text-align: center;
      display: none;
    }
    .form_title{
      color: #313131;
      margin-bottom: 66px;
      text-align: center;
      font-size: 24px;
    }
    .apply_form>div{
      font-size: 18px;
      color: #555;
      margin-bottom: 26px;
      position: relative;
    }
    .message{
      margin-left: 50px;
      width: 418px;
      height: 38px;
      padding-left: 35px;
      border: 1px solid #9a9a9a;
      border-radius: 2px;
    }
    .message:focus{
      border: 1px solid #629bff;
    }
    .icon{
      display: inline-block;
      width: 18px;
      height: 18px;
      position: absolute;
      left: 58px;
      top: 10px;
    }
    .username_icon{
      background: url(http://bu.dressplus.cn/web/img/username_icon.png) center no-repeat;
    }
    .company_name_icon{
      background: url(http://bu.dressplus.cn/web/img/company_name_icon.png) center no-repeat;
    }
    .email_icon{
      background: url(http://bu.dressplus.cn/web/img/email_icon.png) center no-repeat;
    }
    .tel_icon{
      background: url(http://bu.dressplus.cn/web/img/tel_icon.png) center no-repeat;
    }
    .input_err{
      border-color: #f95710 !important;
      background: #ffede5;
    }

    .message::-webkit-input-placeholder { /* WebKit, Blink, Edge */
      font-size: 14px;
    }
    .message:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
      font-size: 14px;
    }
    .message::-moz-placeholder { /* Mozilla Firefox 19+ */
      font-size: 14px;
    }
    .message:-ms-input-placeholder { /* Internet Explorer 10-11 */
      font-size: 14px;
    }

    /*多选框*/
    input[type="checkbox"]{
      appearance: none;
      -webkit-appearance: none;
      outline: none;
      display:none;
    }
    .label_checkbox{
      width:20px;
      height:20px;
      display:inline-block;
      cursor:pointer;
      margin-left: 15px;
    }
    .label_checkbox_image{
      margin-left: 92px;
    }
    .label_checkbox input[type="checkbox"] + span{
      width:20px;
      height:20px;
      display:inline-block;
      vertical-align: middle;
      background:url(http://bu.dressplus.cn/web/img/checkbox_01.gif)  no-repeat;background-position:0 0;
    }
    .label_checkbox input[type="checkbox"]:checked + span{
      background-position:0 -21px
    }

    /*验证码*/
    #captcha{
      width: 135px;
      height: 38px;
      vertical-align: top;
      margin-right: 10px;
      margin-left: 50px;
      padding-left: 10px;
      border: 1px solid #9a9a9a;
    }
    #captcha::-webkit-input-placeholder { /* WebKit, Blink, Edge */
      font-size: 14px;
    }
    #captcha:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
      font-size: 14px;
    }
    #captcha::-moz-placeholder { /* Mozilla Firefox 19+ */
      font-size: 14px;
    }
    #captcha:-ms-input-placeholder { /* Internet Explorer 10-11 */
      font-size: 14px;
    }
    .barter{
      display: inline-block;
      vertical-align: top;
      height: 44px;
      line-height: 44px;
      font-size: 12px;
      margin-left: 20px;
    }
    .application_content{
      margin-left: 50px;
    }
    #barter{
      color:#555;
    }

    /*提交按钮*/
    .apply_form .btn{
      margin: 0;
      text-align: center;
    }
    .submit_btn{
      display: inline-block;
      line-height: 38px;
      text-align: center;
      width: 146px;
      height: 38px;
      background-color: rgba(29,180,255,1);
      border: none;
      outline: none;
      color: #fff;
    }
  }
  @media screen and (max-width: 768px){
    input{
      padding: 0;
      margin: 0;
      box-sizing: border-box;
      outline:none;
    }
    .err{
      font-size: 0.16rem;
      color: #f95710 ;
      position: absolute;
      right: 1rem;
      bottom: -15px;
    }
    #tel_number {
      margin-left: 32px;
    }
    .index_part1{
      position: relative;
      width:100%;
      min-width: 1152px;
    }


    /*内容*/
    #app{
      height: 100%;
    }
    .wrapper{
      height: 100%;
    }
    body,html{
      height: 100%;
    }
    .content{
      height: 100%;
      background: url(http://bu.dressplus.cn/web/img/trial_bj.png) center no-repeat;
      background-size: 100% 100%;
    }
    .form_wrap{
      /*border: 1px solid #000;*/
      width: 100%;
      height: 540px;
      /* margin: 0 auto;*/
      margin-top: 2rem;
      text-align: center;
    }
    .success_msg{
      width: 512px;
      height: 540px;
      margin: 0 auto;
      text-align: center;
      display: none;
    }
    .form_title{
      color: #313131;
      margin-bottom: 0.6rem;
      text-align: center;
      font-size: 0.5rem;
    }
    .apply_form>div{
      font-size: 18px;
      color: #555;
      margin-bottom: 26px;
      position: relative;
    }
    .message{
      width: 80%;
      height: 38px;
      padding-left: 0.8rem;
      border: 1px solid #9a9a9a;
      border-radius: 2px;
    }
    .message:focus{
      border: 1px solid #629bff;
    }
    .icon{
      display: inline-block;
      width: 18px;
      height: 18px;
      position: absolute;
      left: 1.2rem;
      top: 0.25rem;
    }
    .username_icon{
      background: url(http://bu.dressplus.cn/web/img/username_icon.png) center no-repeat;
    }
    .company_name_icon{
      background: url(http://bu.dressplus.cn/web/img/company_name_icon.png) center no-repeat;
    }
    .email_icon{
      background: url(http://bu.dressplus.cn/web/img/email_icon.png) center no-repeat;
    }
    .tel_icon{
      background: url(http://bu.dressplus.cn/web/img/tel_icon.png) center no-repeat;
    }
    .input_err{
      border-color: #f95710 !important;
      background: #ffede5;
    }

    .message::-webkit-input-placeholder { /* WebKit, Blink, Edge */
      font-size: 14px;
    }
    .message:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
      font-size: 14px;
    }
    .message::-moz-placeholder { /* Mozilla Firefox 19+ */
      font-size: 14px;
    }
    .message:-ms-input-placeholder { /* Internet Explorer 10-11 */
      font-size: 14px;
    }

    /*多选框*/
    input[type="checkbox"]{
      appearance: none;
      -webkit-appearance: none;
      outline: none;
      display:none;
    }
    .label_checkbox{width:20px;
      height:20px;
      display:inline-block;
      cursor:pointer;
      margin-left: 15px;

    }
    .label_checkbox input[type="checkbox"] + span{
      width:20px;
      height:20px;
      display:inline-block;
      vertical-align: middle;
      background:url(http://bu.dressplus.cn/web/img/checkbox_01.gif)  no-repeat;background-position:0 0;
    }
    .label_checkbox input[type="checkbox"]:checked + span{
      background-position:0 -21px
    }

    /*验证码*/
    #captcha{
      width: 135px;
      height: 38px;
      vertical-align: top;
      margin-right: 10px;
      padding-left: 10px;
      border: 1px solid #9a9a9a;
    }
    #captcha::-webkit-input-placeholder { /* WebKit, Blink, Edge */
      font-size: 14px;
    }
    #captcha:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
      font-size: 14px;
    }
    #captcha::-moz-placeholder { /* Mozilla Firefox 19+ */
      font-size: 14px;
    }
    #captcha:-ms-input-placeholder { /* Internet Explorer 10-11 */
      font-size: 14px;
    }
    .barter{
      display: inline-block;
      vertical-align: top;
      height: 44px;
      line-height: 44px;
      font-size: 12px;
      margin-left: 20px;
    }
    .application_content{
      width: 90%;
      margin:0 auto ;
    }
    #barter{
      color:#555;
    }

    /*提交按钮*/
    .apply_form .btn{
      margin: 0;
      text-align: center;
    }
    .submit_btn{
      display: inline-block;
      line-height: 38px;
      text-align: center;
      width: 146px;
      height: 38px;
      background-color: rgba(29,180,255,1);
      border: none;
      outline: none;
      color: #fff;
    }
  }



  /*底部样式*/
  /*footer{
    !*margin-top: -171px;*!
  }
  !*媒体选择类型*!
  @media screen and (max-width: 1400px){
    .index_part1_title {
      width: 550px;
      height: 200px;
    }
    .index_part1_content1 {
      margin-top: -150px;
    }
    .index_video_button {
      bottom: 30px;
      width: 115px;
    }
    .td_left {
      width: 45px;
      margin-right: 30px;
    }
    .td_right {
      width: 220px;
    }
    .td_right_p1 {
      font-size: 18px;
    }
    .td_right_p2 {
      font-size: 12px;
    }
  }
  @media screen and (min-width: 1400px) and (max-width:1600px){
    .index_part1_title {
      width: 800px;
      height: 290px;
    }
    .index_video_button {
      width: 135px;
      bottom: 40px;
    }
    .index_part1_content1 {
      margin-top: -180px;
    }
    .index_part1_title p{
      font-size: 34px;
      padding-top: 60px;
    }
    .td_left {
      width: 50px;
      margin-right: 50px;
    }
    .td_right {
      width: 280px;
    }
    .td_right_p1 {
      font-size: 20px;
    }
    .td_right_p2 {
      font-size: 16px;
    }
    .td_right_p2 {
      line-height: 30px;
    }
    .video_p {
      width: 240px;
    }
  }
  @media screen  and (min-width:1600px){
    .index_part1_title {
      width: 900px;
      height: 334px;
    }
    .index_part1_content1 {
      margin-top: -200px;
    }
    .index_video_button {
      width: 155px;
      bottom: 60px;
    }
    .index_part1_title p{
      font-size: 43px;
      padding-top: 85px;
    }
    .td_left {
      width: 55px;
      margin-right: 60px;
    }
    .td_right {
      width: 300px;
    }
    .td_right_p1 {
      font-size: 22px;
    }
    .td_right_p2 {
      font-size: 16px;
    }
    .video_p {
      width: 240px;
    }
  }*/

</style>



// WEBPACK FOOTER //
// src/views/trial.vue